import type { FC } from 'react';
import React from 'react';

import type { AdvertisingButtonProps } from '@src/components/AdvertisingButton';
import { AdvertisingButton } from '@src/components/AdvertisingButton';
import { fullDealCalculatorHasOffersData } from 'entities/FullDeal/config';

type Props = Omit<AdvertisingButtonProps, 'advSub' | 'affSub4'>;

/**
 * @todo: Кнопка с захардкоженными данными по оферу "Займы" (наш офер ПС)
 */
export const ToFullDealAdvertisingButton: FC<Props> = ({ children, ...props }) => (
  <AdvertisingButton
    advSub={fullDealCalculatorHasOffersData.advSub}
    affSub4={fullDealCalculatorHasOffersData.affSub4}
    visibleLabel={children}
    {...props}
  />
);
